// routeStore.js
import Vue from 'vue';
import { routeData } from './data';

const localRouteMap = routeData.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

// 响应式对象，存放全部路由信息
export const routeStore = Vue.observable({
  allRoutes: routeData,
  permRoutes:[],
  breadcrumbItems: [],
  flatRoutes: [],
  friendshipLinks: []
});

// 更新路由信息
export const addRoute = (route) => {
  routeStore.allRoutes.push(route);
};

export const setPermRoutes = (routes = []) => {

  for(const route of routes) {
    const mapRoute = localRouteMap[route.id] || {};
    route.path = mapRoute?.path ||'';
    route.label = route.label
    route.level = 1
    route.level1Id = route.id || null
    route.level1Label = route.label || ''
    route.level2Id = null
    route.level2Label = ''
    route.level3Id = null
    route.level3Label =  ''
    if(route.children) {
      for(const child of route.children) {
        child.path = mapRoute?.path ||'';
        child.pId = route.id || null
        child.level = 2
        child.level1Id = route.id || null
        child.level1Label = route.label || ''
        child.level2Id = child.id || null
        child.level2Label = child.label || ''
        child.level3Id = null
        child.level3Label =  ''
        if(child.children) {
          for(const grandChild of child.children) {
            grandChild.path = mapRoute?.path ||'';
            grandChild.level = 3
            grandChild.level1Id = route.id || null
            grandChild.level1Label = route.label || ''
            grandChild.level2Id = child.id || null
            grandChild.level2Label = child.label || ''
            grandChild.level3Id = grandChild.id || null
            grandChild.level3Label = grandChild.label || ''
          }
        }
      }
    }
  }
  // const finalRoutes = handleRouteLevelPath(routes)
  routeStore.flatRoutes = flattenRoutes(routes);
  routeStore.permRoutes = routes;
};

export const setFriendshipLinks = (links = []) => {
  routeStore.friendshipLinks = links;
};


function handleRouteLevelPath(routes) {
  // 递归遍历每个层级,拼接 组成一个match数组,用于后续匹配路由
  for (const route of routes) {

    if (route.children) {
      handleRouteLevelPath(route.children);
    }
  }
  return routes;
}

function flattenRoutes(routes) {
  return routes.reduce((acc, route) => {
    acc.push(route);
    if (route.children) {
      acc.push(...flattenRoutes(route.children));
    }
    return acc;
  }, []);
}


